import { render } from "./Attendees.vue?vue&type=template&id=1b3690a2&scoped=true"
import script from "./Attendees.vue?vue&type=script&lang=js"
export * from "./Attendees.vue?vue&type=script&lang=js"

import "./Attendees.vue?vue&type=style&index=0&id=1b3690a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b3690a2"

export default script